import girls1 from "../images/girlsGallery/girls1.jpg";
import girls2 from "../images/girlsGallery/girls2.jpg";
import girls3 from "../images/girlsGallery/girls3.jpg";
import girls4 from "../images/girlsGallery/girls4.jpg";
import girls5 from "../images/girlsGallery/girls5.jpg";
import girls6 from "../images/girlsGallery/girls6.jpg";
import girls7 from "../images/girlsGallery/girls7.jpg";
export const girlsData = [
  {
    image: girls1,
  },
  {
    image: girls2,
  },
  {
    image: girls3,
  },
  {
    image: girls4,
  },
  {
    image: girls5,
  },
  {
    image: girls6,
  },
  {
    image: girls7,
  },
];
